var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"emoji"},_vm._l((_vm.emojis),function(emoji){return _c('emoji-icon',{key:emoji,attrs:{"icon":emoji},on:{"click":_vm.onClick}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }